import React, {useRef} from "react";
import {DropdownButton} from "./cell";
import {useState} from "react";
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Tooltip from "@mui/material/Tooltip";
import CheckIcon from "@mui/icons-material/Check";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";


const identity = (x) => x;


const Dropdown = ({
                      value,
                      options,
                      multiple=false,
                      onSelect = f => f,
                      renderValue = identity,
                      renderOptions = identity,
                      getOptionValue = identity,
                      changed,
                      warning,
                      error,
                      tooltip,
                      buttonWidth,
                  }) => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event?.relatedTarget)) {
            return;
        }
        setOpen(false);
    }

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    }

    const handleSelect = (option) => {
        const optionValue = getOptionValue(option);

        if (multiple === true) {
            // if the option is already selected, deselect it, otherwise select it
            if (value.some(v => optionValue === v)) {
                onSelect(value.filter(v => optionValue !== v));
            } else {
                onSelect([...value, optionValue]);
            }
        } else{
            onSelect(optionValue);
        }
        handleClose();
    }

    const isSelected = React.useCallback(
        (option) => value.some(v => v === getOptionValue(option)),
        [value, getOptionValue]
    );

    return <>
        <Tooltip title={tooltip} placement="top" disableInteractive>
            <DropdownButton ref={anchorRef}
                            onClick={handleToggle}
                            changed={changed}
                            warning={warning}
                            error={error}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup={open ? 'menu' : undefined}
                            width={buttonWidth}>
                {renderValue(value)}
            </DropdownButton>
        </Tooltip>

        {
            open && <Popper
                sx={{
                    zIndex: 1510,
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper sx={{maxHeight: "200px", overflow: 'auto'}}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem>
                                    {options.map(option => {
                                        return <MenuItem key={getOptionValue(option)}
                                                  selected={value === option}
                                                  onClick={() => handleSelect(option)}
                                        >
                                            {
                                                multiple && <ListItemIcon sx={{minWidth: 32}}>
                                                    {isSelected(option) ? <CheckIcon fontSize="small"/> : null}
                                                </ListItemIcon>
                                            }
                                            <ListItemText primaryTypographyProps={{variant: "body2"}}>
                                                {renderOptions ? renderOptions(option) : String(option)}
                                            </ListItemText>
                                        </MenuItem>
                                    })}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        }
    </>;
}

export default Dropdown;